import dynaForms from '@elab/core/utils/dynaForms';
import { selectors as checkoutSelectors } from '@elab/core/store/checkout';

import { storeName } from './types';

const getDeliveryAddressForm = state => state[storeName] || {};
const getDeliveryAddressFormOperation = state => getDeliveryAddressForm(state).profileOperation;
const getDeliveryAddressFormData = state => getDeliveryAddressForm(state).data || {};
const getDeliveryTime = state => {
    const deliveryTime = getDeliveryAddressFormData(state).deliveryTime || {};
    return deliveryTime && (deliveryTime.value || null);
};
const getDeliveryTimeValues = state => {
    const deliveryTimeValues = getDeliveryAddressFormData(state).deliveryTime || {};
    return (deliveryTimeValues && deliveryTimeValues.values) || [];
};

const useAlternativeDeliveryAddress = state =>
    getDeliveryAddressFormData(state).addAddress &&
    getDeliveryAddressFormData(state).addAddress.value;

const getDeliveryModes = state => getDeliveryAddressForm(state).deliveryModes || [];
const isSubmitDisabled = state => {
    return (
        (checkoutSelectors.getDeliveryMode(state) !== 'pickup' &&
            getDeliveryTime(state) === null) ||
        (checkoutSelectors.getDeliveryMode(state) === 'pickup' &&
            checkoutSelectors.getSelectedStore(state) === false)
    );
};

export default {
    ...dynaForms.getSelectors(storeName),
    getDeliveryModes,
    getDeliveryAddressFormOperation,
    getDeliveryTime,
    getDeliveryTimeValues,
    getDeliveryAddressFormData,
    useAlternativeDeliveryAddress,
    isSubmitDisabled,
};
